initSlider = function(id) {
    const el = document.getElementById(id);
    const slider = el.querySelector('.slider-holder');
    const sliderItems = slider.querySelectorAll('.slide-item');
    const sliderButtonLeft = el.querySelector('.slide-left');
    const sliderButtonRight = el.querySelector('.slide-right');
    let dragging = false;
    let shouldDrag = false;
    let startX, scrollLeft;

    let moveRight = function (e) {
        let endPosition = 0;
        let done = false;
        let firstOffset = sliderItems[0].offsetLeft;
        sliderItems.forEach((element) => {
            if (!done) {
                if (slider.scrollLeft+1 >= (element.offsetLeft - firstOffset)) {
                    endPosition = element.offsetLeft - firstOffset;
                } else {
                    endPosition = element.offsetLeft - firstOffset;
                    done = true;
                }
            }
        })
        //maxPosition -= slider.offsetWidth;
        slider.scroll({left: endPosition, behavior: 'smooth'});
        if ((slider.scrollWidth - slider.clientWidth) <= endPosition) {
            sliderButtonRight.classList.add("disabled");
        } else {
            sliderButtonRight.classList.remove("disabled");
        }
        sliderButtonLeft.classList.remove("disabled");
    }
    let moveLeft = function (e) {
        let endPosition = 0;
        let done = false;
        let firstOffset = sliderItems[0].offsetLeft;
        sliderItems.forEach((element) => {
            if (!done) {
                if (slider.scrollLeft > (element.offsetLeft - firstOffset)) {
                    endPosition = element.offsetLeft - firstOffset;
                } else {
                    done = true;
                }
            }

        })
        slider.scroll({left: endPosition, behavior: 'smooth'});
        if (endPosition <= 0) {
            sliderButtonLeft.classList.add("disabled");
        } else {
            sliderButtonLeft.classList.remove("disabled");
        }
        sliderButtonRight.classList.remove("disabled");
    }

    let startDragging = function (e) {
        shouldDrag = true;
        dragging = false;
        if (e.type == 'mousedown') {
            startX = e.pageX - slider.offsetLeft;
        } else if (e.type == 'touchstart') {
            startX = e.touches[0].pageX - slider.offsetLeft;
        }
        scrollLeft = slider.scrollLeft;
    };
    let stopDragging = function (e) {
        if (dragging) {
            e.preventDefault();
            e.stopPropagation();
            let endPosition = 0;
            sliderItems.forEach((element) => {
                if (Math.abs(slider.scrollLeft - (endPosition + element.offsetWidth)) <
                    Math.abs(slider.scrollLeft - endPosition)) {
                    endPosition += element.offsetWidth;
                }
            })

            // don't snap to individual items if scrolled all the way to the left
            if (slider.scrollWidth - slider.clientWidth < slider.scrollLeft)
                slider.scroll({left: endPosition, behavior: 'smooth'});

            if (endPosition <= 0) {
                sliderButtonLeft.classList.add("disabled");
            } else {
                sliderButtonLeft.classList.remove("disabled");
            }
            if ((slider.scrollWidth - slider.clientWidth) <= slider.scrollLeft) {
                sliderButtonRight.classList.add("disabled");
            } else {
                sliderButtonRight.classList.remove("disabled");
            }
        }
        shouldDrag = false;
    };

    let drag = function (e) {
        e.preventDefault();
        if (shouldDrag) {
            dragging = true;
            if (e.type == 'mousemove') {
                const x = e.pageX - slider.offsetLeft;
                const scroll = x - startX;
                slider.scrollLeft = scrollLeft - scroll;
            } else if (e.type == 'touchmove') {
                const x = e.touches[0].pageX - slider.offsetLeft;
                const scroll = x - startX;
                slider.scrollLeft = scrollLeft - scroll;
            }
        }
    }
    let clickItem = function (e) {
        if (dragging) {
            e.preventDefault();
        }
    }

    slider.addEventListener('mousemove', drag);
    slider.addEventListener('mousedown', startDragging);
    slider.addEventListener('mouseup', stopDragging);
    slider.addEventListener('click', clickItem);
    slider.addEventListener('mouseleave', stopDragging);

    slider.addEventListener('touchstart', startDragging);
    slider.addEventListener('touchend', stopDragging);
    slider.addEventListener('touchcancel', stopDragging);
    slider.addEventListener("touchmove", drag);

    sliderButtonRight.addEventListener('click', moveRight);
    sliderButtonLeft.addEventListener('click', moveLeft);
}


positionArrows = function(id){
    const el = document.getElementById(id);

    const viewportWidth = el.querySelector('.slider-holder').clientWidth;
    el.querySelectorAll('.slide-item').forEach((element) => {
        element.style.setProperty("--viewport-width", viewportWidth+'px');
    });

    const image = el.querySelector('.card-img-ref');
    el.querySelector('.left-arrow').style.top = ((image.offsetHeight/2)-(53/2))+'px';
    el.querySelector('.right-arrow').style.top = ((image.offsetHeight/2)-(53/2))+'px';
}
